var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4233 3.18303C11.769 2.93899 12.2309 2.93899 12.5767 3.18303L21.0767 9.18303C21.3421 9.37041 21.5 9.67508 21.5 10C21.5 10.3249 21.3421 10.6296 21.0767 10.817L12.5767 16.817C12.2309 17.061 11.769 17.061 11.4233 16.817L2.92331 10.817C2.65786 10.6296 2.49999 10.3249 2.49999 10C2.49999 9.67508 2.65786 9.37041 2.92331 9.18303L11.4233 3.18303ZM5.23405 10L12 14.776L18.7659 10L12 5.22404L5.23405 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68302 13.4233C3.00152 12.9721 3.62548 12.8645 4.07667 13.183L12 18.776L19.9233 13.183C20.3745 12.8645 20.9985 12.9721 21.317 13.4233C21.6355 13.8745 21.5279 14.4985 21.0767 14.817L12.5767 20.817C12.2309 21.061 11.769 21.061 11.4233 20.817L2.92331 14.817C2.47211 14.4985 2.36453 13.8745 2.68302 13.4233Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteLayers);
export default __webpack_public_path__ + "static/media/route-layers.a80353162a6b73f9b0050454c55eceb6.svg";
export { ForwardRef as ReactComponent };